import { EMPTY_FUNCTION } from '../../../cdk/utils';
import type { InputAdapter } from './input.adapter';

export class TextAdapter implements InputAdapter<string> {
  format(value: string): string {
    return value;
  }

  parse(value: string): string | null {
    return value;
  }

  keydownHandler = EMPTY_FUNCTION;
}
